module.exports = __webpack_public_path__ + "img/unlock.1459ca0b.svg";